<template>
  <DataGridColumn v-bind="$attrs" v-on="$listeners">
    <template slot-scope="scope">
      <template v-if="isRenderColumn">
        <slot v-bind="scope"/>
      </template>
      <span v-else v-html="getRenderCellValue(scope.row, tableColumn.prop, scope.isHidden)"></span>
    </template>
  </DataGridColumn>
</template>

<script>
import { getValueByPath } from 'element-ui/lib/utils/util'
import DataGridColumn from '../DataGridColumn'

export default {
  name: 'DataGridColumnWrapper',
  components: {DataGridColumn},
  props: {
    tableColumn: {
      type: Object,
      required: true
    },
    tableColumnCellRender: {
      type: Function,
      required: true
    }
  },
  computed: {
    isRenderColumn: function () {
      return !!(this.tableColumn.renderAction || this.tableColumn.renderCell)
    }
  },
  methods: {
    getRenderCellValue (row, prop, isHidden) {
      if (isHidden) {
        return getValueByPath(row, prop)
      } else {
        return this.tableColumnCellRender(row, prop, getValueByPath(row, prop))
      }
    }
  }
}
</script>
